export const brandFonts = {
  primary:
    '"Avenir Next", "Avenir", "Trebuchet MS", "Helvetica Neue", Helvetica, Arial, sans-serif',
};
